import {
  GlobalSixItemCategories,
  GravityPicture,
} from '../../../generated/graphql'
import { pictureBuilder } from '../../../transformers/picture'
import { ResolverProvider } from '../types'

export type GlobalSixItemCategoriesPicture = Omit<
  GlobalSixItemCategories,
  'id' | 'query'
> & {
  pictures: {
    pictureOne: GravityPicture
    pictureTwo: GravityPicture
    pictureThree: GravityPicture
    pictureFour: GravityPicture
    pictureFive: GravityPicture
    pictureSix: GravityPicture
  }
}

export const GlobalSixItemCategoriesPicture: ResolverProvider = () => async (
  parent: GlobalSixItemCategories,
): Promise<{
  pictureOne: GravityPicture
  pictureTwo: GravityPicture
  pictureThree: GravityPicture
  pictureFour: GravityPicture
  pictureFive: GravityPicture
  pictureSix: GravityPicture
  __typename: 'GlobalSixItemCategoriesPicture'
}> => {
  const pictures = pictureBuilder({
    pictureOne: {
      alt: parent.altItemOne || parent.itemOneTitle || '',
      sources: [
        {
          url: parent.itemOneImage || '',
          imageWidth: 343,
          minWidth: 1200,
        },
        {
          url: parent.itemOneImage || '',
          imageWidth: 244,
          minWidth: 900,
        },
        {
          url: parent.itemOneImage || '',
          imageWidth: 126,
          minWidth: 0,
          default: true,
        },
      ],
    },
    pictureTwo: {
      alt: parent.altItemTwo || parent.itemTwoTitle || '',
      sources: [
        {
          url: parent.itemTwoImage || '',
          imageWidth: 343,
          minWidth: 1200,
        },
        {
          url: parent.itemTwoImage || '',
          imageWidth: 244,
          minWidth: 900,
        },
        {
          url: parent.itemTwoImage || '',
          imageWidth: 126,
          minWidth: 0,
          default: true,
        },
      ],
    },
    pictureThree: {
      alt: parent.altItemThree || parent.itemThreeTitle || '',
      sources: [
        {
          url: parent.itemThreeImage || '',
          imageWidth: 343,
          minWidth: 1200,
        },
        {
          url: parent.itemThreeImage || '',
          imageWidth: 244,
          minWidth: 900,
        },
        {
          url: parent.itemThreeImage || '',
          imageWidth: 126,
          minWidth: 0,
          default: true,
        },
      ],
    },
    pictureFour: {
      alt: parent.altItemFour || parent.itemThreeTitle || '',
      sources: [
        {
          url: parent.itemFourImage || '',
          imageWidth: 343,
          minWidth: 1200,
        },
        {
          url: parent.itemFourImage || '',
          imageWidth: 244,
          minWidth: 900,
        },
        {
          url: parent.itemFourImage || '',
          imageWidth: 126,
          minWidth: 0,
          default: true,
        },
      ],
    },
    pictureFive: {
      alt: parent.altItemFive || parent.itemFiveTitle || '',
      sources: [
        {
          url: parent.itemFiveImage || '',
          imageWidth: 343,
          minWidth: 1200,
        },
        {
          url: parent.itemFiveImage || '',
          imageWidth: 244,
          minWidth: 900,
        },
        {
          url: parent.itemFiveImage || '',
          imageWidth: 126,
          minWidth: 0,
          default: true,
        },
      ],
    },
    pictureSix: {
      alt: parent.altItemSix || parent.itemSixTitle || '',
      sources: [
        {
          url: parent.itemSixImage || '',
          imageWidth: 343,
          minWidth: 1200,
        },
        {
          url: parent.itemSixImage || '',
          imageWidth: 244,
          minWidth: 900,
        },
        {
          url: parent.itemSixImage || '',
          imageWidth: 126,
          minWidth: 0,
          default: true,
        },
      ],
    },
  })

  return {
    pictureOne: pictures.pictureOne,
    pictureTwo: pictures.pictureTwo,
    pictureThree: pictures.pictureThree,
    pictureFour: pictures.pictureFour,
    pictureFive: pictures.pictureFive,
    pictureSix: pictures.pictureSix,
    __typename: 'GlobalSixItemCategoriesPicture',
  }
}
